module.exports = __webpack_public_path__ + "static/media/riivi-brand.4cfd95a1.svg";